/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  REQUEST_HUBS,
  FETCH_HUBS_SUCCESS,
  FETCH_HUBS_FAILURE,
  FETCH_HUBS,
  POLL_HUBS_START,
  POLL_HUBS_STOP,
  SELECTED_HUB
} from './actionTypes'

export function requestHubs() {
  return {
    type: REQUEST_HUBS
  }
}

export function fetchHubsSuccess(json) {
  return {
    type: FETCH_HUBS_SUCCESS,
    hubs: json
  }
}

export function fetchHubsFailure(error) {
  return {
    type: FETCH_HUBS_FAILURE,
    errorMessage: error.message
  }
}

export function fetchHubs() {
  return {
    type:FETCH_HUBS
  }
}

export function pollHubsStart() {
  //console.log("Start polling hubs in action of pollHubsStart")
  return {
    type:POLL_HUBS_START
  }
}

export function pollHubsStop() {
  //console.log("Stop polling hubs in action for pollHubsStop")
  return {
    type:POLL_HUBS_STOP
  }
}

export function setSelectedHub(hub){
  return{
    type:SELECTED_HUB,
    selectedHub:hub
  }
}


